import { render, staticRenderFns } from "./ForceRepwd.vue?vue&type=template&id=18164f11&"
import script from "./ForceRepwd.vue?vue&type=script&lang=js&"
export * from "./ForceRepwd.vue?vue&type=script&lang=js&"
import style0 from "./ForceRepwd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports